import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import './Slider.css';
import SliderModal from './SliderModal';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import Swal from 'sweetalert2';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, LucideToggleLeft, LucideToggleRight, Pencil, Trash2 } from 'lucide-react';
import { useSearch } from '../../SearchContext';
import Loader from '../Loader';
import { decryptToken } from '../utils/getToken';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';


const isSliderActive = (status) => String(status || "Active").toLowerCase() === "active";

const parseSliderProduct = (product) => {
    let parsedProduct = product;
    try {
        if (typeof parsedProduct === "string") {
            parsedProduct = JSON.parse(parsedProduct);
            if (typeof parsedProduct === "string") {
                parsedProduct = JSON.parse(parsedProduct);
            }
        }
    } catch (e) {
        console.warn("Error parsing product:", e);
        parsedProduct = {};
    }
    return parsedProduct;
};

const Slider = () => {

    const url = API_BASE_URL;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [data, setData] = useState({
        image: "",
        background_image: "",
        slider_name: "",
        description: "",
        price: "",
        cutOffPrice: "",
        product: [],
        product_id: "",
        offer_name: "",
        user_id: isLoggedIn.main_id,
        user_name: isLoggedIn.full_name,
        mobile_image: "",
        link: ""
    })
    const [slider, setSlider] = useState([])
    const [load, setLoad] = useState(false);
    const { globalSearch } = useSearch();
    const token = decryptToken("accessToken") || ""


    // State Variables
    // const [globalSearch, setglobalSearch] = useState('');
    // const [ageGroups, setAgeGroups] = useState([
    //     // Sample data (replace with actual data)
    //     { minAge: 18, maxAge: 25, status: 'Active' },
    //     { minAge: 26, maxAge: 35, status: 'Deactive' },
    //     { minAge: 36, maxAge: 50, status: 'Active' },
    // ]);
    const [filteredAgeGroups, setFilteredAgeGroups] = useState(slider);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const location = useLocation()

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("openSlider") === "true") {
            const newUrl = `${window.location.pathname}`;
            window.history.replaceState({}, "", newUrl);
            setIsModalOpen(true)
        }
    }, [location]);

    // Effect to handle filtering
    useEffect(() => {
        const filtered = slider.filter((group) =>
            Object.values(group).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredAgeGroups(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [globalSearch, slider]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredAgeGroups.length / itemsPerPage);
    const currentData = filteredAgeGroups.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // // Handlers
    // const handleSearch = (e) => setglobalSearch(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const toggleStatus = async (id) => {
        try {
            const response = await fetch(`${url}/slider/toggle-status/${id}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const res = await response.json();

            if (response.ok) {
                setSlider((prev) =>
                    prev.map((item) =>
                        String(item.id) === String(id) ? { ...item, status: res.status } : item
                    )
                );
                toast.success(res.message || `Status updated to ${res.status}`);
            } else {
                toast.error(res.message || "Failed to toggle status");
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to toggle status");
        }
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "This will permanently delete the slider!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${url}/slider/${id}`, {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });

                const res = await response.json();

                if (response.ok) {
                    Swal.fire('Deleted!', 'Slider has been deleted.', 'success');
                    sliderFetch(); // Refresh the slider list
                } else {
                    Swal.fire('Error!', res.message || 'Failed to delete.', 'error');
                }
            } catch (error) {
                Swal.fire('Error!', 'Something went wrong.', 'error');
                console.error(error);
            }
        }
    };
    const sliderFetch = async () => {
        setLoad(true);
        try {
            const response = await fetch(
                `${url}/slider/all/${isLoggedIn.main_id}?includeInactive=true`,
                {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            const res = await response.json();
            ;
            setSlider(res);
        } catch (error) {
            console.error(error);
        } finally {
            setLoad(false);
        }
    }

    useEffect(() => {
        sliderFetch();
    }, [])

    const openEditModal = (group) => {
        setData({
            ...group,
            product: parseSliderProduct(group.product),
        });
        setIsModalOpen(true);
    };

    if (load) {
        return (
            <Loader />
        );
    }


    return (
        <div className="slider-page">
            <div className="oms-header">
                <h1 className="dashboard-title">Slider</h1>
            </div>

            {/* Search Filter */}
            {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={globalSearch}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> 
                    </div>
                </div> */}

            {/* Age Groups Table */}
            <div className="customer-table responsive-table">
                <table>
                    <thead>
                        <tr>
                            <th>Image</th>
                            <th>Mobile Image</th>
                            {/* <th>Name</th>
                                <th>Price</th>
                                <th>Cut Off</th> */}
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentData.length > 0 ? (
                            currentData.map((group, index) => (
                                <tr key={index}>
                                    <td>
                                        <img src={group.image} alt="" style={{ width: "50px", height: "50px" }} />
                                    </td>
                                    <td>
                                        <img src={group.mobile_image} style={{ width: "50px", height: "50px" }} alt="" />
                                    </td>
                                    {/* <td>{group.slider_name || "N/A"}</td>
                                        <td>{group.price || "N/A"}</td>
                                        <td>{group.cutOffPrice || "N/A"}</td> */}
                                    <td>
                                        <button
                                            className={`status-toggle ${isSliderActive(group.status) ? "Active" : "Inactive"}`}
                                            onClick={() => toggleStatus(group.id)}
                                        >
                                            {isSliderActive(group.status) ? (
                                                <i className="fas fa-toggle-on"></i>
                                            ) : (
                                                <i className="fas fa-toggle-off"></i>
                                            )}
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                            className="edit-button"
                                            // onClick={() => {
                                            //     setData(group); // 👈 preload the selected group's data including `_id`
                                            //     setIsModalOpen(true);
                                            // }}
                                            onClick={() => openEditModal(group)}


                                        >
                                            <i className="fa-solid fa-pencil edit-oms"></i>
                                        </button>

                                        <button
                                            className="delete-button"
                                            onClick={() => handleDelete(group.id)} // or group._id
                                        >
                                            <i className="fa-solid fa-trash delete-oms"></i>
                                        </button>

                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" style={{ textAlign: 'center' }}>
                                    No Slider added.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="ecom-responsive-cards">
                {currentData.length === 0 ? (
                    <p style={{ textAlign: "center", margin: "50px" }}>No Sliders added</p>
                ) : (
                    currentData.map((group, index) => (
                        <div className="ecom-responsive-card slider-mobile-card" key={index}>
                            <div className="slider-mobile-images">
                                <div>
                                    <p className="slider-mobile-images__label">Desktop</p>
                                    {group.image ? (
                                        <img src={group.image} alt="Desktop" className="slider-mobile-images__img" />
                                    ) : (
                                        <div className="slider-mobile-images__placeholder">No image</div>
                                    )}
                                </div>
                                <div>
                                    <p className="slider-mobile-images__label">Mobile</p>
                                    {group.mobile_image ? (
                                        <img src={group.mobile_image} alt="Mobile" className="slider-mobile-images__img" />
                                    ) : (
                                        <div className="slider-mobile-images__placeholder">No image</div>
                                    )}
                                </div>
                            </div>

                            <div className="slider-mobile-stack">
                                <button
                                    type="button"
                                    className={`slider-mobile-stack__btn slider-mobile-stack__btn--status status-toggle ${isSliderActive(group.status) ? "Active" : "Inactive"}`}
                                    onClick={() => toggleStatus(group.id)}
                                >
                                    {isSliderActive(group.status) ? (
                                        <>
                                            <LucideToggleRight />
                                            <span>Active</span>
                                        </>
                                    ) : (
                                        <>
                                            <LucideToggleLeft />
                                            <span>Inactive</span>
                                        </>
                                    )}
                                </button>
                                <button
                                    type="button"
                                    className="slider-mobile-stack__btn slider-mobile-stack__btn--edit"
                                    onClick={() => openEditModal(group)}
                                >
                                    <Pencil size={20} />
                                    <span>Edit</span>
                                </button>
                                <button
                                    type="button"
                                    className="slider-mobile-stack__btn slider-mobile-stack__btn--delete"
                                    onClick={() => handleDelete(group.id)}
                                >
                                    <Trash2 size={20} />
                                    <span>Delete</span>
                                </button>
                            </div>
                        </div>
                    ))
                )}

            </div>
            {/* {totalPages > 1 && ( */}

            <div className="pagination">
                {/* First Page */}
                <button
                    onClick={() => paginate(1)}
                    disabled={currentPage === 1}
                    className="pagination-chev-btn"
                >
                    <ChevronsLeft size={18} />
                </button>

                {/* Previous Page */}
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="pagination-chev-btn"
                >
                    <ChevronLeft size={18} />
                </button>

                {/* Current Page Number Only */}
                <button className="pagination-btn active">
                    {currentPage}
                </button>

                {/* Next Page */}
                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="pagination-chev-btn"
                >
                    <ChevronRight size={18} />
                </button>

                {/* Last Page */}
                <button
                    onClick={() => paginate(totalPages)}
                    disabled={currentPage === totalPages}
                    className="pagination-chev-btn"
                >
                    <ChevronsRight size={18} />
                </button>
            </div>
            {/* )} */}

            <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
                <button
                    onClick={() => {
                        // Reset the form to default empty values
                        setData({
                            image: "",
                            background_image: "",
                            slider_name: "",
                            description: "",
                            price: "",
                            cutOffPrice: "",
                            product: [],
                            offer_name: "",
                            product_id: "",
                            user_id: isLoggedIn.main_id,
                            user_name: isLoggedIn.full_name,
                            link: ""
                        });
                        setIsModalOpen(true);
                    }}
                    className="cssbuttons-io-button">
                    <span>Add Slider</span>
                </button>
            </div>

            <SliderModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} data={data} setData={setData} sliderFetch={sliderFetch} />
        </div>
    );
};

export default Slider;
